var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFiles = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2 0C0.99 0 0.0110003 0.99 0.0110003 2.2L0 19.8C0 21.01 0.979 22 2.189 22H15.4C16.61 22 17.6 21.01 17.6 19.8V6.6L11 0H2.2ZM9.9 7.7V1.65L15.95 7.7H9.9Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFiles);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_files.47cd52afb8bfa59200da7884ed5d1fc5.svg";